<template>
  <div>
    <el-card shadow="always">
      <el-page-header
        v-if="id === ''"
        @back="back"
        title
        :content="$t('adicionar-novo-remetente')"
      ></el-page-header>
      <el-page-header
        v-if="id !== ''"
        @back="back"
        title
        :content="$t('atualizar-remetente')"
      ></el-page-header>
    </el-card>
    <el-card>
      <el-form
        :model="ruleForm"
        ref="ruleForm"
        label-position="top"
        :status-icon="true"
        :rules="rules"
        :inline-message="true"
      >
        <el-form-item
          :label="user.type === '2' ? $t('filial') : $t('cliente')"
          prop="code"
          v-if="user.type !== '5' && !id"
        >
          <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8">
            <CustomerList
              v-model="ruleForm.customer"
              v-bind:current="ruleForm.customer"
              v-bind:customerType="user.type === '2' ? 3 : ''"
            />
          </el-col>
        </el-form-item>
        <el-form-item :label="$t('nome')" prop="name">
          <el-input ref="name" v-model="ruleForm.name"></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('cpf/cnpj')"
          prop="federalId"
          class="is-required"
        >
          <el-col :xs="24" :sm="12" :md="6" :lg="3" :xl="3">
            <el-input
              v-model="ruleForm.federalId"
              v-mask="['NNN.NNN.NNN-NN', 'NN.NNN.NNN/NNNN-##']"
            ></el-input>
          </el-col>
        </el-form-item>
        <el-form-item :label="$t('cep')" prop="zipcode">
          <el-col :xs="14" :sm="6" :md="6" :lg="3" :xl="3">
            <el-input
              maxlength="9"
              v-model="ruleForm.zipcode"
              v-mask="'#####-###'"
              @blur="zipcode()"
            ></el-input>
          </el-col>
        </el-form-item>
        <el-form-item :label="$t('endereco')" prop="address">
          <el-input v-model="ruleForm.address"></el-input>
        </el-form-item>
        <el-row :gutter="5">
          <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="10">
            <el-form-item :label="$t('bairro')" prop="neighborhood">
              <el-input v-model="ruleForm.neighborhood"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="8">
            <el-form-item :label="$t('cidade')" prop="city">
              <el-input v-model="ruleForm.city"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="6">
            <el-form-item :label="$t('estado')" prop="state">
              <el-input v-model="ruleForm.state"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :xs="12" :sm="4" :md="4" :lg="2" :xl="2">
            <el-form-item :label="$t('numero')" prop="number">
              <el-input
                type="number"
                maxlength="6"
                v-model="ruleForm.number"
                v-mask="'######'"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12">
            <el-form-item :label="$t('complemento')" prop="complement">
              <el-input v-model="ruleForm.complement"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <br />
        <el-form-item style="text-align: center">
          <el-button
            v-if="id === ''"
            type="warning"
            autofocus
            @click="submitForm('ruleForm')"
            >{{ $t("adicionar") }}</el-button
          >
          <el-button
            v-if="id !== ''"
            type="warning"
            autofocus
            @click="editForm('ruleForm')"
            >{{ $t("atualizar") }}</el-button
          >
          <el-button type="danger" @click="back()">{{
            $t("voltar")
          }}</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template> 
<script>
import { PostOfficeService } from "@/services/post.office/post.office.services";
import { SendersService } from "@/services/senders/senders.services";
import { CpfHelpers } from "@/xpost/helpers/cpf";
import { CnpjHelpers } from "@/xpost/helpers/cnpj";
import { i18n } from "@/plugin/i18n";
import CustomerList from "@/xpost/views/register/customer/CustomerList";
import { UserService } from "@/services/users/user.services";

export default {
  name: "RecipientSender",
  components: {
    CustomerList,
  },
  data() {
    var checkFederalid = (rule, value, callback) => {
      if (value.length == 14) {
        CpfHelpers.checkCpf(rule, value, callback);
      } else if (value.length == 18) {
        CnpjHelpers.checkCnpj(rule, value, callback);
      }
      return callback();
    };
    return {
      id: "",
      user: {
        type: "2",
      },
      ruleForm: {
        name: "",
        customer: "",
        federalId: "",
        cnpj: "",
        address: "",
        city: "",
        state: "",
        neighborhood: "",
        number: "",
        complement: "",
      },
      rules: {
        name: [
          {
            required: true,
            message: i18n.tc("nome-obrigatorio"),
            trigger: "blur",
          },
        ],
        zipcode: [
          {
            required: true,
            message: i18n.tc("cep-obrigatorio"),
            trigger: "blur",
          },
        ],
        federalId: {
          validator: checkFederalid,
          trigger: "blur",
        },
      },
    };
  },
  methods: {
    back() {
      var vm = this;
      vm.$router.replace({ name: "sender" });
    },
    get() {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      SendersService.get(vm.id)
        .then((response) => {
          vm.ruleForm = response;
          //          vm.ruleForm.extent = response.complement;
          vm.ruleForm.customer = response.customers.id;
        })
        .catch((error) => {
          vm.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => loading.close());
    },
    submitForm(formName) {
      const vm = this;
      vm.$refs[formName].validate((valid) => {
        if (valid) {
          if (vm.ruleForm.address === "") {
            return vm.$message({
              type: "error",
              message: i18n.tc("cep-invalido"),
            });
          }
          const loading = vm.$loading(vm.$options.loading);
          SendersService.add(vm.ruleForm)
            .then((response) => {
              this.$message({
                type: "success",
                message: i18n.tc("remetente-criado-sucesso"),
              });
            })
            .catch((error) => {
              vm.$message({ type: "error", message: error });
            })
            .finally(() => loading.close());
        } else {
          return false;
        }
      });
    },
    editForm(formName) {
      const vm = this;
      vm.$refs[formName].validate((valid) => {
        if (valid) {
          if (vm.ruleForm.address === "") {
            return vm.$message({
              type: "error",
              message: i18n.tc("cep-invalido"),
            });
          }

          const loading = vm.$loading(vm.$options.loading);
          SendersService.update(vm.id, vm.ruleForm)
            .then((response) => {
              this.$message({
                type: "success",
                message: i18n.tc("remetente-atualizado-sucesso"),
              });
            })
            .catch((error) => {
              vm.$message({
                type: "error",
                message: error.message,
              });
            })
            .finally(() => loading.close());
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    zipcode() {
      const vm = this;
      if (!vm.ruleForm.zipcode) {
        return false;
      }
      const loading = vm.$loading(vm.$options.loading);
      PostOfficeService.zipcode(vm.ruleForm.zipcode)
        .then((response) => {
          vm.ruleForm.address = response.end;
          vm.ruleForm.city = response.cidade;
          vm.ruleForm.state = response.uf;
          vm.ruleForm.neighborhood = response.bairro;
        })
        .catch((error) => {
          vm.$notify.error({
            title: "Erro",
            message: i18n.tc("cep-invalido"),
          });
        })
        .finally(() => loading.close());
    },
  },
  mounted() {
    const vm = this;
    UserService.me()
      .then((response) => {
        vm.user.type = response.type;
        if (vm.$route.params.id) {
          vm.id = vm.$route.params.id;
          vm.get();
        } else {
          vm.$refs.name.$el.children[0].focus();
        }
      })
      .catch((error) => {
        vm.$message({
          type: "error",
          message: error,
        });
      });
  },
};
</script>
<style scoped>
.el-page-header__left {
  display: flex !important;
}
form {
  margin-top: 20px;
}
@media screen and (min-width: 458px) {
  .col-form-label {
    text-align: right;
  }
}
</style>
